import {
  ORGANIZATION_CHART_FETCHING,
  ORGANIZATION_CHART_SUCCESS,
  ORGANIZATION_CHART_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ORGANIZATION_CHART_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ORGANIZATION_CHART_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ORGANIZATION_CHART_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
